import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ModalWindow from "../ModalWindow.vue";
import AdminNoteList from "./AdminNoteList.vue";
import { ref, watchEffect } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminNoteModal',
    props: {
        noteableId: {},
        noteableType: {},
        mode: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const show = ref(false);
        const close = () => {
            emits("close");
        };
        const mode = ref(props.mode);
        const noteableId = ref(props.noteableId);
        const noteableType = ref(props.noteableType);
        watchEffect(() => {
            mode.value = props.mode;
            noteableId.value = props.noteableId;
            noteableType.value = props.noteableType;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalWindow, {
                "is-visible": show.value,
                onClose: close
            }, {
                title: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("h3", null, "メモ", -1)
                ])),
                default: _withCtx(() => [
                    _createVNode(AdminNoteList, {
                        "noteable-id": noteableId.value,
                        "noteable-type": noteableType.value,
                        mode: mode.value
                    }, null, 8, ["noteable-id", "noteable-type", "mode"])
                ]),
                _: 1
            }, 8, ["is-visible"]));
        };
    }
});
